var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "TicketSettings" } }, [
    _c(
      "div",
      { staticClass: "tabs" },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "button",
          {
            key: tab.id,
            class: { active: _vm.selectedTab === tab.id },
            on: {
              click: function ($event) {
                _vm.selectedTab = tab.id
              },
            },
          },
          [_vm._v("\n            " + _vm._s(tab.label) + "\n        ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content" }, [
      _vm.selectedTab === "TicketForwarding"
        ? _c("div", [_c("TicketForwarding")], 1)
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }